$(document).ready(function() {
	var formTypeSerialNumber = 'SERIAL_NUMBER';
	var formTypeInvalidRequest = 'INVALID_NUMBER_REQUEST';
	
	$(document).on('submit', '.form-serial-number__form form[data-form-type]', function($event) {
		$event.preventDefault();
		var form = $(this);
		var formParent = form.parents('.form-serial-number__form');
		var postContainer = form.parents('.form-serial-number');
		var postId = postContainer.data('postId');

		var formType = form.data('formType');
		if(formType == formTypeSerialNumber) {
			var formData = {
				postId: postId,
				serialNumber: form.find('input[name="serial_number"]').val().replace(/^\s+|\s+$/g,''),
			};
			postContainer.find('.form-serial-number__result').removeClass('form-serial-number__result--visible');
			postContainer.find('.form__email-result').hide();
			if(formData.serialNumber != null && formData.serialNumber != '') {
				formParent.find('.form__validation.form__validation--error').hide();
				form.addClass('loading');
				jQuery.ajax({
					url: form.attr('action'),
					type: 'POST',
					data: formData,
					dataType: 'JSON',
					cache: false,
					success: function(response) {
						if(response.success) {
							postContainer.find('.form-serial-number__result.form-serial-number__result--success').addClass('form-serial-number__result--visible');
							form.find('input[name="serial_number"]').val('');
						} else {
							postContainer.find('form[data-form-type="'+formTypeInvalidRequest+'"]').attr('data-serial-number', formData.serialNumber);
							postContainer.find('.form-serial-number__result.form-serial-number__result--error').addClass('form-serial-number__result--visible');
						}
					},
					complete: function() {
						form.removeClass('loading');
					}
				});
			} else {
				formParent.find('.form__validation.form__validation--error').fadeIn();
			}
		} else if(formType == formTypeInvalidRequest) {
			formParent.find('.form__email-result').hide();
			var formData = {
				postId: postId,
				email: form.find('input[name="email"]').val().replace(/^\s+|\s+$/g,''),
				serialNumber: form.attr('data-serial-number'),
			};
			if(formData.email != null && formData.email != '') {
				formParent.find('.form__validation.form__validation--error').hide();
				form.addClass('loading');
				jQuery.ajax({
					url: form.attr('action'),
					type: 'POST',
					data: formData,
					dataType: 'JSON',
					cache: false,
					success: function(response) {
						formParent.find('.form__email-result').html(response.message).fadeIn();
						if(response.success) {
							form.find('input[name="email"]').val('');
						}
					},
					complete: function() {
						form.removeClass('loading');
					}
				});
			} else {
				formParent.find('.form__validation.form__validation--error').fadeIn();
			}
		}
	});
});